import React,{useState, useEffect}  from 'react';

import Sides from '../Bars/Pythonsidebar';

import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";

function Pdict(){

    const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
     <div>
<Sides/>

<Helmet>
 
  <title>Learn Free Python Dictionaries Beginners Tutorials CodeExampler</title>
<meta name="description" content="Python dictionary tutorial for beginners.dictionary is also a data structure Will be used defining a dictionary.Dictionaries are used due to limitation of the list
The list is not enough to represent the data" />
<meta name="keywords" content="codeexampler,programming language,python dictionary add,python dictionary methods,python dictionary iterate,python dictionary append
,python dictionary get,python dictionary sort,python dictionary list,python dictionary of lists,python dictionary keys,python dictionary loop,python dictionary for loop,
,python dictionary example"/>
<link rel="canonical" href="https://www.codeexampler.com/python-dictionary" />
</Helmet>

<div className='lg:pl-56'>


    <h1 className="m-4 mh1">Python Dictionaries Tutorial
    </h1>

    <div className="first">
        <a href="/python-object-and-class">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/python-tuple">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>


    <p className="mt-4 para">That is also a data structure that Will be used to defining a dictionary.
</p>
<h2 className="mt-4 mh2">Python Dictionaries Keys:</h2>
<p className="mt-4 para">A dictionary as a mapping between a set of indices is known as<span className="bold"> Python Dictionaries keys.</span></p>

<h2 className="mt-4 mh2">Python Dictionaries Explained</h2>
<p className="mt-4 para">Python Dictionaries Explained create a new dictionary with no items. 
Dictionaries use due to the limitation of the list is not enough to represent the data.
</p>
<h2 className="mt-4 mh2">Creating a Python dictionary Syntax:</h2>


       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"500vh"}}>
          <code >
            {"\n"}
                <span className="qwerty-7">Dict</span>
                <span className="qwerty-1">.</span>
                <span className="qwerty-4">name</span>
                <span className="qwerty-1"> = </span>
                <span className="qwerty-1">&#123;</span>
                <span className="qwerty-6">'</span>
                <span className="qwerty-3">key1</span>
                <span className="qwerty-6">'</span>
                <span className="qwerty-1">:</span>
                <span className="qwerty-6">'</span>
                <span className="qwerty-10">value</span>
                <span className="qwerty-6">'</span>
                <span className="qwerty-1">,</span>
                <span className="qwerty-6">'</span>
                <span className="qwerty-3">key2</span>
                <span className="qwerty-6">'</span>
                <span className="qwerty-1">:</span>
                <span className="qwerty-6">'</span>
                <span className="qwerty-10">value</span>
                <span className="qwerty-6">'</span>
                <span className="qwerty-1">&#125;</span>
            {"\n"}{"\n"}
                 </code>
        </pre>
        </div>   

<h2 className="mt-4 mh2">Python Dictionaries Examples:</h2>

<br/>


<h2 className='headings'>Q-Python Dictionaries Students Basic Example?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-4">student</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-1">&#123;</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-3">Name</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">:</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-10">Ram</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-3">class</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">:</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-10">8</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-3">subject</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">:</span>
                 <span className="qwerty-1">[</span>
                 <span className="qwerty-1">'</span>
                 <span className="qwerty-10">English</span>
                 <span className="qwerty-1">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-1">'</span>
                 <span className="qwerty-10">Physics</span>
                 <span className="qwerty-1">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-1">'</span>
                 <span className="qwerty-10">History</span>
                 <span className="qwerty-1">'</span>
                 <span className="qwerty-1">]</span>
                 <span className="qwerty-1">&#125;</span>
             {"\n"}
                 <span className="qwerty-8">print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">student</span>
                 <span className="qwerty-1">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>  
         <h5 className='headings'> Output : </h5>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
            <pre style={{maxHeight:"100vh"}}>
                <code >
                    {"\n"}
                    <span className="qwerty-1">&#123;</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-3">Name</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">:</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-8">Ram</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-3">class</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">:</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-8">8</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-3">subject</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">:</span>
                 <span className="qwerty-6">[</span>
                 <span className="qwerty-1">'</span>
                 <span className="qwerty-8">English</span>
                 <span className="qwerty-1">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-1">'</span>
                 <span className="qwerty-8">Physics</span>
                 <span className="qwerty-1">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-1">'</span>
                 <span className="qwerty-8">History</span>
                 <span className="qwerty-1">'</span>
                 <span className="qwerty-6">]</span>
                 <span className="qwerty-1">&#125;</span>
                        {"\n"}      {"\n"}      
              </code>
                </pre>
                </div> 



<h2 className='headings'>Q-Python Dictionaries Colors example?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-4">Color_no</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-1">&#123;</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-3">color</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">:</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-10">red</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-3">points</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">:</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-10">6</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">&#125;</span>
             {"\n"}
                 <span className="qwerty-8">print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">Color_no</span>
                 <span className="qwerty-1">[</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-3">color</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">]</span>
                 <span className="qwerty-1">)</span>
             {"\n"}
                 <span className="qwerty-8">print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">Color_no</span>
                 <span className="qwerty-1">[</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-3">points</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">]</span>
                 <span className="qwerty-1">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>  
         <h5 className='headings'> Output : </h5>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
            <pre style={{maxHeight:"100vh"}}>
                <code >
                    {"\n"}
                 <span className="qwerty-6">red</span>
                    {"\n"}
                 <span className="qwerty-6">6</span>
                        {"\n"}      {"\n"}      
              </code>
                </pre>
                </div>   

<h2 className="mt-4 mh2">Accessing Python dictionary</h2>
<p className="mt-4 para"><span className="bold">Print(0)</span>-error! Because never index in dictionaries   with integer indices
</p>


<h2 className='headings'>Q-Python Dictionaries Students Subject Example?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-4">student</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-1">&#123;</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-3">Name</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">:</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-10">Ram</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-3">class</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">:</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-10">8</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-3">subject</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">:</span>
                 <span className="qwerty-1">[</span>
                 <span className="qwerty-1">'</span>
                 <span className="qwerty-10">English</span>
                 <span className="qwerty-1">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-1">'</span>
                 <span className="qwerty-10">Physics</span>
                 <span className="qwerty-1">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-1">'</span>
                 <span className="qwerty-10">History</span>
                 <span className="qwerty-1">'</span>
                 <span className="qwerty-1">]</span>
                 <span className="qwerty-1">&#125;</span>
             {"\n"}
                 <span className="qwerty-8">print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">student</span>
                 <span className="qwerty-1">[</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-3">subject</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">]</span>
                 <span className="qwerty-1">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>  
         <h5 className='headings'> Output : </h5>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
            <pre style={{maxHeight:"100vh"}}>
                <code >
                    {"\n"}
                 <span className="qwerty-6">[</span>
                 <span className="qwerty-1">'</span>
                 <span className="qwerty-8">English</span>
                 <span className="qwerty-1">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-1">'</span>
                 <span className="qwerty-8">Physics</span>
                 <span className="qwerty-1">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-1">'</span>
                 <span className="qwerty-8">History</span>
                 <span className="qwerty-1">'</span>
                 <span className="qwerty-6">]</span>
                        {"\n"}      {"\n"}      
              </code>
                </pre>
                </div>   


<h2 className="mt-4 mh2">Q-Adding data inside the empty Python dictionary?</h2>


        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-4">detail</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-1">&#123;</span>
                 <span className="qwerty-1">&#125;</span>
             {"\n"}
             <span className="qwerty-4">detail</span>
                 <span className="qwerty-1">[</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-3">Name</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">]</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-10">Ram</span>
                 <span className="qwerty-6">'</span>
             {"\n"}
             <span className="qwerty-4">detail</span>
                 <span className="qwerty-1">[</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-3">percentage</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">]</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-10">98</span>
             {"\n"}                
                 <span className="qwerty-8">print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">detail</span>
                 <span className="qwerty-1">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>  
         <h5 className='headings'> Output : </h5>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
            <pre style={{maxHeight:"100vh"}}>
                <code >
                    {"\n"}
                    <span className="qwerty-1">&#123;</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-3">name</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">:</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-8">Ram</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-3">percentage</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">:</span>
                 <span className="qwerty-8">98</span>
                 <span className="qwerty-1">&#125;</span>
                        {"\n"}      {"\n"}      
              </code>
                </pre>
                </div>   


<h2 className="mt-4 mh2">Q-Python nested Students dictionary Comprehension?</h2>



        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-4">students</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-1">&#123;</span>
             {"\n"}
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-2">students1</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">:</span>
                 <span className="qwerty-1">&#123;</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-3">Name</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">:</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-10">Ram</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-3">percentage</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">:</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-10">98</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">&#125;</span>
                 <span className="qwerty-1">,</span>
             {"\n"}
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-2">students2</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">:</span>
                 <span className="qwerty-1">&#123;</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-3">Name</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">:</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-10">Lakshman</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-3">percentage</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">:</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-10">96</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">&#125;</span>
             {"\n"}
                 <span className="qwerty-1">&#125;</span>
             {"\n"}
                 <span className="qwerty-8">print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">students</span>
                 <span className="qwerty-1">)</span>
             {"\n"}
                 <span className="qwerty-8">print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">students</span>
                 <span className="qwerty-1">[</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-2">students1</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">]</span>
                 <span className="qwerty-1">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>  
         <h5 className='headings'> Output : </h5>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
            <pre style={{maxHeight:"100vh"}}>
                <code >
                    {"\n"}
                    <span className="qwerty-1">&#123;</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-2">students1</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">:</span>
                 <span className="qwerty-1">&#123;</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-3">Name</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">:</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-10">Ram</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-3">percentage</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">:</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-10">98</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">&#125;</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-2">students2</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">:</span>
                 <span className="qwerty-1">&#123;</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-3">Name</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">:</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-10">Lakshman</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-3">percentage</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">:</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-10">96</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">&#125;</span>
                 <span className="qwerty-1"> &#125;</span>
                    {"\n"}
                    <span className="qwerty-1">&#123;</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-3">Name</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">:</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-8">Ram</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-3">percentage</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">:</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-8">98</span>
                 <span className="qwerty-6">'</span>
                
                 <span className="qwerty-1">&#125;</span>
                        {"\n"}      {"\n"}      
              </code>
                </pre>
                </div>   

<p className="mt-4 para">You already knew about key and value in previous Python dictionaries points, so focus On these topics.</p>

<h2 className="mt-4 mh2">Check if the key exists in the dictionary:
</h2>

        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-4">students</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-1">&#123;</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-3">Name</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">:</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-10">Anmol Chaudhary</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-3">age</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">:</span>                 
                 <span className="qwerty-10">28</span>
                 <span className="qwerty-1">&#125;</span>
             {"\n"}
                 <span className="qwerty-6">if </span>
                 <span className="qwerty-1">'</span>
                 <span className="qwerty-3">Name</span>
                 <span className="qwerty-1">' </span>
                 <span className="qwerty-5">in </span>
                 <span className="qwerty-4">students</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
             <span className="qwerty-8">  print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-6">'</span> 
                 <span className="qwerty-10">present</span>
                 <span className="qwerty-6">'</span> 
                 <span className="qwerty-1">)</span>
             {"\n"}
                 <span className="qwerty-6">else </span>
                 <span className="qwerty-1">:</span>
             {"\n"}
                 <span className="qwerty-8">  print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-6">'</span> 
                 <span className="qwerty-10">not present</span>
                 <span className="qwerty-6">'</span> 
                 <span className="qwerty-1">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>  
         <h5 className='headings'> Output : </h5>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
            <pre style={{maxHeight:"100vh"}}>
                <code >
                    {"\n"}
                 <span className="qwerty-2">present</span>
                        {"\n"}      {"\n"}      
              </code>
                </pre>
                </div>        


<h2 className="mt-4 mh2">Check if the value in python dictionary:</h2>




<h2 className='headings'>Q-Write a Program Python Dictionaries Example:</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-4">students</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-1">&#123;</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-3">Name</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">:</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-10">Lakshmana</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-3">age</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">:</span>                 
                 <span className="qwerty-10">28</span>
                 <span className="qwerty-1">&#125;</span>
             {"\n"}
                 <span className="qwerty-6">if </span>
                 <span className="qwerty-1">'</span>
                 <span className="qwerty-7">Lakshmana</span>
                 <span className="qwerty-1">' </span>
                 <span className="qwerty-5">in </span>
                 <span className="qwerty-4">students</span>
                 <span className="qwerty">.</span>
                 <span className="qwerty-2">values</span>
                 <span className="qwerty-1">()</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
             <span className="qwerty-8">  print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-6">'</span> 
                 <span className="qwerty-10">present</span>
                 <span className="qwerty-6">'</span> 
                 <span className="qwerty-1">)</span>
             {"\n"}
                 <span className="qwerty-6">else </span>
                 <span className="qwerty-1">:</span>
             {"\n"}
                 <span className="qwerty-8">  print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-6">'</span> 
                 <span className="qwerty-10">not present</span>
                 <span className="qwerty-6">'</span> 
                 <span className="qwerty-1">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>  
         <h5 className='headings'> Output : </h5>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
            <pre style={{maxHeight:"100vh"}}>
                <code >
                    {"\n"}
                 <span className="qwerty-2">present</span>
                        {"\n"}      {"\n"}      
              </code>
                </pre>
                </div> 


<h2 className="mt-4 mh2">Check Full List in Dictionary:</h2>





<h2 className='headings'>Q-Write a Program to Check Values Python Dictionaries Example?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-4">students</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-1">&#123;</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-3">Name</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">:</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-10">Ram</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-3">age</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">:</span>                 
                 <span className="qwerty-10">28</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-3">subject</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">:</span>                 
                 <span className="qwerty-1">[</span>                 
                 <span className="qwerty-6">'</span>                 
                 <span className="qwerty-10">English</span>  
                 <span className="qwerty-6">'</span>                
                 <span className="qwerty-1">,</span>                 
                 <span className="qwerty-6">'</span>                 
                 <span className="qwerty-10">Physics</span>                 
                 <span className="qwerty-6">'</span>                 
                 <span className="qwerty-1">,</span>                 
                 <span className="qwerty-6">'</span>                 
                 <span className="qwerty-10">History</span>                 
                 <span className="qwerty-6">'</span>                 
                 <span className="qwerty-1">]</span>                 
                 <span className="qwerty-1">&#125;</span>
             {"\n"}
                 <span className="qwerty-6">if </span>
                 <span className="qwerty-1">[</span>                 
                 <span className="qwerty-6">'</span>                 
                 <span className="qwerty-10">English</span> 
                 <span className="qwerty-6">'</span>                 
                 <span className="qwerty-1">,</span>                 
                 <span className="qwerty-6">'</span>                 
                 <span className="qwerty-10">Physics</span>                 
                 <span className="qwerty-6">'</span>                 
                 <span className="qwerty-1">,</span>                 
                 <span className="qwerty-6">'</span>                 
                 <span className="qwerty-10">History</span>                 
                 <span className="qwerty-6">'</span>                 
                 <span className="qwerty-1">] </span>   
                 <span className="qwerty-5">in </span>
                 <span className="qwerty-4">students</span>
                 <span className="qwerty">.</span>
                 <span className="qwerty-2">values</span>
                 <span className="qwerty-1">()</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
                 <span className="qwerty-8">  print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-6">'</span> 
                 <span className="qwerty-10">present</span>
                 <span className="qwerty-6">'</span> 
                 <span className="qwerty-1">)</span>
             {"\n"}
                 <span className="qwerty-6">else </span>
                 <span className="qwerty-1">:</span>
             {"\n"}
                 <span className="qwerty-8">  print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-6">'</span> 
                 <span className="qwerty-10">not present</span>
                 <span className="qwerty-6">'</span> 
                 <span className="qwerty-1">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>  
         <h5 className='headings'> Output : </h5>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
            <pre style={{maxHeight:"100vh"}}>
                <code >
                    {"\n"}
                 <span className="qwerty-2">present</span>
                        {"\n"}      {"\n"}      
              </code>
                </pre>
                </div>   

<h2 className="mt-4 mh2">Python Loop in a dictionary</h2>
<p className="mt-4 para">In a Python dictionary, loop print uses both keys and values.
</p>



<h2 className='headings'>Q-Python For Loop Basics Dictionaries Example?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-4">Student</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-1">&#123;</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-3">Name</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">:</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-10">Ram</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-3">age</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">:</span>                 
                 <span className="qwerty-10">22</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-3">percentage</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">:</span>                 
                 <span className="qwerty-10">98</span>                 
                 <span className="qwerty-1">&#125;</span>
             {"\n"}
                 <span className="qwerty-7">for </span>
                 <span className="qwerty-6">i </span>                 
                 <span className="qwerty-5">in </span>                 
                 <span className="qwerty-4">Student</span>                 
                 <span className="qwerty-1">:</span>
             {"\n"}
                 <span className="qwerty-8">    print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-6">i</span>
                 <span className="qwerty-1">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>  
         <h5 className='headings'> Output : </h5>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
            <pre style={{maxHeight:"100vh"}}>
                <code >
                    {"\n"}
                 <span className="qwerty-2">name</span>
                    {"\n"}
                 <span className="qwerty-2">age</span>
                    {"\n"}
                 <span className="qwerty-2">percentage</span>
                        {"\n"}      {"\n"}      
              </code>
                </pre>
                </div>   


<h2 className="mt-4 mh2">Python Loop For Values:</h2>



<h2 className='headings'>Q-Python Dictionaries For Loop by Using Values() Function Example?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-4">Student</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-1">&#123;</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-3">Name</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">:</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-10">Ram</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-3">age</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">:</span>                 
                 <span className="qwerty-10">22</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-3">percentage</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">:</span>                 
                 <span className="qwerty-10">98</span>                 
                 <span className="qwerty-1">&#125;</span>
             {"\n"}
                 <span className="qwerty-7">for </span>
                 <span className="qwerty-6">i </span>                 
                 <span className="qwerty-5">in </span>                 
                 <span className="qwerty-4">Student</span>                 
                 <span className="qwerty">.</span>
                 <span className="qwerty-2">values</span>
                 <span className="qwerty-1">()</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
                 <span className="qwerty-8">    print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-6">i</span>
                 <span className="qwerty-1">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>  
         <h5 className='headings'> Output : </h5>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
            <pre style={{maxHeight:"100vh"}}>
                <code >
                    {"\n"}
                 <span className="qwerty-2">Ram</span>
                    {"\n"}
                 <span className="qwerty-2">22</span>
                    {"\n"}
                 <span className="qwerty-2">98</span>
                        {"\n"}      {"\n"}      
              </code>
                </pre>
                </div> 


<h3 className="mt-4 mh3">Same As</h3>


<h2 className='headings'>Q-Python Dictionaries For Loop by Using [i] Example?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-4">Student</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-1">&#123;</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-3">Name</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">:</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-10">Ram</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-3">age</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">:</span>                 
                 <span className="qwerty-10">22</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-3">percentage</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">:</span>                 
                 <span className="qwerty-10">98</span>                 
                 <span className="qwerty-1">&#125;</span>
             {"\n"}
                 <span className="qwerty-7">for </span>
                 <span className="qwerty-6">i </span>                 
                 <span className="qwerty-5">in </span>                 
                 <span className="qwerty-4">Student</span>                 
                 <span className="qwerty-1">:</span>
             {"\n"}
                 <span className="qwerty-8">    print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">Student</span>
                 <span className="qwerty-1">[</span>
                 <span className="qwerty-6">i</span>
                 <span className="qwerty-1">]</span>
                 <span className="qwerty-1">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>  
         <h5 className='headings'> Output : </h5>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
            <pre style={{maxHeight:"100vh"}}>
                <code >
                    {"\n"}
                 <span className="qwerty-2">Ram</span>
                    {"\n"}
                 <span className="qwerty-2">22</span>
                    {"\n"}
                 <span className="qwerty-2">98</span>
                        {"\n"}      {"\n"}      
              </code>
                </pre>
                </div>   

<h2 className="mt-4 mh2">Python Dictionaries Value():</h2>
<h3 className="mt-4 mh3">Python Dictionaries Value () Method</h3>
<p className="mt-4 para">This Method uses to access the values.
</p>


<h2 className='headings'>Q-Python Dictionaries Value() Method Example?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-4">Student</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-1">&#123;</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-3">Name</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">:</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-10">Ram</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-3">age</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">:</span>                 
                 <span className="qwerty-10">22</span>
                 <span className="qwerty-1">&#125;</span>
             {"\n"}
                 <span className="qwerty-6">x </span>                 
                 <span className="qwerty-1"> = </span>                 
                 <span className="qwerty-4">Student</span>                 
                 <span className="qwerty">.</span>
                 <span className="qwerty-2">values</span>
                 <span className="qwerty-1">()</span>
          
             {"\n"}
                 <span className="qwerty-8">print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-6">x</span>
                 <span className="qwerty-1">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>  
         <h5 className='headings'> Output : </h5>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
            <pre style={{maxHeight:"100vh"}}>
                <code >
                    {"\n"}
                 <span className="qwerty-2">dict_values</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-1">[</span>
                 <span className="qwerty-1">'</span>
                 <span className="qwerty-3">Ram</span>
                 <span className="qwerty-1">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-2">22</span>
                 <span className="qwerty-1">]</span>
                 <span className="qwerty-1">)</span>
                        {"\n"}      {"\n"}      
              </code>
                </pre>
                </div> 


<h2 className="mt-4 mh2">Python Dictionaries Keys():</h2>
<h3 className="mt-4 mh3">Python Dictionaries Keys() Method:</h3>
<p className="mt-4 para">This method uses to access the values.</p>



<h2 className='headings'>Q-Python Dictionaries Keys() Method Example?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-4">Student</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-1">&#123;</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-3">Name</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">:</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-10">Ram</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-3">age</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">:</span>                 
                 <span className="qwerty-10">22</span>
                 <span className="qwerty-1">&#125;</span>
             {"\n"}
                 <span className="qwerty-6">x </span>                 
                 <span className="qwerty-1"> = </span>                 
                 <span className="qwerty-4">Student</span>                 
                 <span className="qwerty">.</span>
                 <span className="qwerty-8">keys</span>
                 <span className="qwerty-1">()</span>
             
             {"\n"}
                 <span className="qwerty-8">print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-6">x</span>
                 <span className="qwerty-1">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>  
         <h5 className='headings'> Output : </h5>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
            <pre style={{maxHeight:"100vh"}}>
                <code >
                    {"\n"}
                 <span className="qwerty-8">dict_keys</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-1">[</span>
                 <span className="qwerty-1">'</span>
                 <span className="qwerty-3">Name</span>
                 <span className="qwerty-1">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-1">'</span>
                 <span className="qwerty-3">Age</span>
                 <span className="qwerty-1">'</span>
                 <span className="qwerty-1">]</span>
                 <span className="qwerty-1">)</span>
                        {"\n"}      {"\n"}      
              </code>
                </pre>
                </div>   


<h2 className="mt-4 mh2">Python Dictionaries items():</h2>
<h3 className="mt-4 mh3">Python Dictionaries Items() Method:</h3>

        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-4">Student</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-1">&#123;</span>
                 <span className="qwerty-1">&#125;</span>
             {"\n"}
                 <span className="qwerty-6">x </span>                 
                 <span className="qwerty-1"> = </span>                 
                 <span className="qwerty-4">Student</span>                 
                 <span className="qwerty">.</span>
                 <span className="qwerty-2">items</span>
                 <span className="qwerty-1">()</span>
                
             {"\n"}
                 <span className="qwerty-8">print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-6">x</span>
                 <span className="qwerty-1">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>  
         <h5 className='headings'> Output : </h5>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
            <pre style={{maxHeight:"100vh"}}>
                <code >
                    {"\n"}
                 <span className="qwerty-8">dict_items</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-6">[</span>
                 <span className="qwerty-6">]</span>
                 <span className="qwerty-1">)</span>
                        {"\n"}      {"\n"}      
              </code>
                </pre>
                </div> 


<h2 className="mt-4 mh2">Python Dictionaries combine Values and Keys:</h2>


        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-4">Student</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-1">&#123;</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-3">Name</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">:</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-10">Ram</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-3">age</span>
                 <span className="qwerty-6">'</span>
                 <span className="qwerty-1">:</span>                 
                 <span className="qwerty-10">22</span>
                 <span className="qwerty-1">&#125;</span>
             {"\n"}
                 <span className="qwerty-7">for </span>
                 <span className="qwerty-6">k</span>                 
                 <span className="qwerty-1">,</span>                 
                 <span className="qwerty-6">v </span>                 
                 <span className="qwerty-5">in </span>                 
                 <span className="qwerty-4">Student</span>                 
                 <span className="qwerty">.</span>
                 <span className="qwerty-2">items</span>
                 <span className="qwerty-1">()</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
                 <span className="qwerty-8">    print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-6">k</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">v</span>
                 <span className="qwerty-1">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>  
         <h5 className='headings'> Output : </h5>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
            <pre style={{maxHeight:"100vh"}}>
                <code >
                    {"\n"}
                 <span className="qwerty-2">Name </span>
                 <span className="qwerty-3">Ram</span>
                    {"\n"}
                 <span className="qwerty-2">Age </span>
                 <span className="qwerty-3">22</span>
                        {"\n"}      {"\n"}      
              </code>
                </pre>
                </div> 

  <h1 className="mt-5">  </h1>
       
  <div className="back">
        <a href="/python-object-and-class">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="python-tuple">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div></div>
)

}
export default Pdict;